import { render, staticRenderFns } from "./QuotationVendorMailModal.vue?vue&type=template&id=4d94bf18&scoped=true&"
import script from "./QuotationVendorMailModal.vue?vue&type=script&lang=js&"
export * from "./QuotationVendorMailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d94bf18",
  null
  
)

export default component.exports